import React from 'react';
import { Card, CardContent, Grid, TextField, Typography } from '@material-ui/core';

const QuotePageFinancialSummary = ({
    totalItems,
    discount,
    totalFinal,
    onDiscountChange,
    userRole = 'tecnico',
    classes = {},
    currentLanguage
}) => {

    const formatCurrency = (valor) => {
        return new Intl.NumberFormat(currentLanguage.lang_code === 'en' ? 'en-US' : 'pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(valor);
    };

    if (userRole !== 'admin') return null;

    return (
        <Card className={classes.card} style={{ marginBottom: 24, padding: 16 }}>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    {currentLanguage.bepiService.workshop.workshop_quote_finance_summary}
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label={currentLanguage.bepiService.workshop.workshop_quote_total_items_label}
                            value={formatCurrency(totalItems)}
                            InputProps={{ readOnly: true }}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label={currentLanguage.bepiService.workshop.workshop_quote_discount_label}
                            type="number"
                            value={discount}
                            onChange={onDiscountChange}
                            InputProps={{ inputProps: { min: 0 } }}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label={currentLanguage.bepiService.workshop.workshop_quote_total_final_label}
                            value={formatCurrency(totalFinal)}
                            InputProps={{ readOnly: true }}
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default QuotePageFinancialSummary;
